"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMessage = exports.StyledIcon = exports.StyledLabel = exports.StyledTextInputContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = __importDefault(require("src/components/Box"));
var makeFontSize_1 = __importDefault(require("src/utilities/styled/makeFontSize"));
var margin_1 = __importDefault(require("src/utilities/styled/margin"));
var makeColor_1 = __importDefault(require("src/components/Inputs/utilities/makeColor"));
var Typography_1 = require("src/components/Typography");
var makeIconColor_1 = __importDefault(require("./utilities/makeIconColor"));
var StyledTextInputContainer = (0, styled_components_1.default)(Box_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  ", ";\n"], ["\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  ", ";\n"])), makeIconColor_1.default);
exports.StyledTextInputContainer = StyledTextInputContainer;
var StyledLabel = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), (0, makeFontSize_1.default)('text'), makeColor_1.default, function (_a) {
    var theme = _a.theme;
    return ((0, margin_1.default)({ theme: theme, margin: [0, 0, 1, 0] }));
});
exports.StyledLabel = StyledLabel;
var StyledIcon = (0, styled_components_1.default)(Box_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  ", ";\n"], ["\n  display: flex;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  ", ";\n"])), function (_a) {
    var reverse = _a.reverse;
    return (reverse ? 'left: 10px' : 'right: 10px');
});
exports.StyledIcon = StyledIcon;
var StyledMessage = (0, styled_components_1.default)(Typography_1.Small)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return ((0, margin_1.default)({ theme: theme, margin: [1, 0, 0, 0] }));
}, function (_a) {
    var theme = _a.theme, messageType = _a.messageType;
    return (messageType === 'error' ? theme.palette.inputBorder[2] : theme.palette.inputBorder[1]);
});
exports.StyledMessage = StyledMessage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
